// Shared by AudioWaveformPlayer and VideoPlayer — a precise, continuously
// updating mm:ss for a live scrubber position, distinct from format.ts's
// durationOrDash (a static, compact "5m 12s" summary elsewhere on the page).
export function formatTime(seconds: number): string {
  if (!Number.isFinite(seconds) || seconds < 0) return '0:00';
  const m = Math.floor(seconds / 60);
  const s = Math.floor(seconds % 60);
  return `${m}:${String(s).padStart(2, '0')}`;
}
